import classNames from "classnames";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { toast } from "react-toastify";
import { Api } from "../../../../services/api";

function ListaTemasDialog(props) {
  const [buttonRef, setButtonRef] = useState('')

  function load(e) {
    if (e === buttonRef)
      return true;

    return false
  }

  const deleteTheme = async (e) => {
    const tema_id = e.customizacao_credor_id;
    setButtonRef(tema_id);
    try {
      await Api.delete(`/customizacaoCredor/deleta/${tema_id}`);
      toast.success('Tema excluído com sucesso');
      props.reload();
    } catch (error) {
      toast.error('Erro ao excluir tema');
      console.log(error);
    }
    finally {
      setButtonRef('');
    }
  }

  const deleteBody = (rowData) => (
    <div>
      <Button
        rounded
        severity="danger"
        icon={<FaTimes />}
        onClick={() => deleteTheme(rowData)}
        loading={load(rowData.customizacao_credor_id)}
      />
    </div>
  )

  const editBody = (rowData) => (
    <div>
      <Button
        rounded
        severity="info"
        icon={<FaPencil />}
        onClick={() => props.updateTheme(rowData)}
      />
    </div>
  )

  const statusBodyTemplate = (rowData) => {
    let type = "bg-red-300 text-red-700";
    let value = "INATIVO"
    if (rowData.customizacao_status === true) {
      type = "bg-emerald-300 text-emerald-800";
      value = "ATIVO"
    }
    return (
      <div className="flex justify-center items-center ">
        <span className={classNames(
          'text-nowrap py-1 px-2 justify-center flex w-auto',
          type
        )}
        >
          <p className="uppercase text-sm font-bold">
            {value}
          </p>
        </span>
      </div>
    )
  }

  return (
    <Dialog
      visible
      header="Temas criados"
      onHide={() => props.close()}
      pt={{
        root: 'w-screen md:w-[70vw] max-h-[80vh] ',
        header: classNames('flex items-center justify-between shrink-0',
          'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
          'dark:bg-gray-900  dark:text-white/80'),
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[80vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow": state.maximized
          })
        }),
      }}
    >
      <div className="">
        <DataTable
          value={props.themeList}
          onSelectionChange={(e) => props.selectTheme(e)}
          selectionMode="single"
          emptyMessage="Nenhum tema criado"
        >
          <Column style={{ width: '17rem' }} header="Data Criação" field="created_at" body={rowData => format(new Date(rowData.created_at), 'dd/MM/yyyy kk:mm:ss')} />
          <Column style={{ width: '12rem' }} header="Descrição" field="descricao" />
          <Column style={{ width: '6rem' }} header="Excluir" body={rowData => deleteBody(rowData)} />
          <Column style={{ width: '6rem' }} header="Editar" body={rowData => editBody(rowData)} />
          <Column style={{ width: '6rem' }} header="Status" body={rowData => statusBodyTemplate(rowData)} />
        </DataTable>
      </div>
    </Dialog>
  )
}

export default ListaTemasDialog